import './AccessRemoved.scss';
import sadEmoji from "../../img/sad_emoji.webp";
import MhmLogoRedBackground from "../icons/MhmLogoRedBackground";
import {Button} from "../account/misc/Button";
import {logout} from "../../service/AuthService";
import {env} from "../../env/env";

export default function AccessRemoved() {

  function signOut() {
    logout().then(() => {
      window.location.href = env.basePath;
    });
  }

  return <div className={'access-removed'}>
    <div className={'content'}>
      <img src={sadEmoji} alt={''}/>
      <span className={'title'}>You no longer have access</span>
      <span className={'subtitle'}>If this change is unexpected, please contact the account owner.</span>
      <Button className={'sign-out'} onClick={signOut}>Sign out</Button>
    </div>
    <div className={'ftr'}><MhmLogoRedBackground/></div>
  </div>
}
